import React, { useContext, useEffect, useState } from "react";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faChevronDown } from "@fortawesome/free-solid-svg-icons";

import LocaleList from "../../image-editing/components/locale-list";

import { getLookups, getShotTemplate } from "../../photography/lib/photoData";
import { TaskContext } from "../../../contexts/task";

const ImageReview = ({ shots = [] }) => {
    const { task } = useContext(TaskContext);
    const { shipmentKey, shipmentProductKey, photographyWipKey } = task.context;
    const [showImages, setShowImages] = useState(true);
    const [state, setState] = useState({
        packageType: "",
    });

    useEffect(() => {
        async function init() {
            const photographyLookups = await getLookups();
            const photographyTemplate = await getShotTemplate(photographyWipKey);

            const packageType =
                photographyLookups.packageTypes && photographyTemplate && photographyTemplate.packageType
                    ? photographyLookups.packageTypes.find((p) => p.id === photographyTemplate.packageType)
                    : null;
            setState({
                packageType: packageType && packageType.name ? packageType.name : "",
                // shots: shots,
            });
        }
        init();
    }, []);

    const accordionClick = () => {
        setShowImages(!showImages);
    };

    const imageClick = () => {
        window.open(`/image-browser/${shipmentKey}/${shipmentProductKey}/edited`, "_blank");
    };

    return (
        <div className="image-review">
            <div className="accordion">
                <div className="accordion-section">
                    <div
                        className="accordion-title -clickable"
                        onClick={accordionClick}
                    >
                        <div className="icon">
                            <button>
                                <FontAwesomeIcon icon={showImages ? faChevronDown : faChevronRight} />
                            </button>
                        </div>
                        <div className="label">
                            <h3 className="-tighten-margin">Edited Images</h3>
                        </div>
                        <div className="empty-space txt-right">
                            <div className="txt-normal">Package Type:</div>
                            {state.packageType}
                            <br />
                            <br />
                        </div>
                    </div>
                    <div className={classnames("accordion-content", { "-active": showImages })}>
                        <div
                            key="edited-image-gallery"
                            label={<h2>Edited Images</h2>}
                        >
                            <LocaleList
                                shots={shots}
                                imageClick={imageClick}
                                shipmentKey={shipmentKey}
                                shipmentProductKey={shipmentProductKey}
                                isFinalQa
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImageReview;
